import { FormProps } from '@omilia/chat-ui';

export type UrlSelectMethod = 'ROUND_ROBIN' | 'ORDERED';

interface Meta {
  [key: string]: string;
}

export interface MetaPayload {
  type: 'META_DATA';
  meta: Meta;
}

type ObjectMessage = {
  type: string;
};

type Message = string | ObjectMessage;

export interface ThreadMessages {
  keepVisible: boolean;
  message: Message;
  owner: string;
  timestamp: string;
  type: string;
  withAgent: boolean;
  sequence_id: number;
  isSensitive?: boolean;
}

export interface Footer {
  showFooter?: boolean;
  text?: string;
  logoURL?: string;
}

export interface Notifications {
  withBubble?: boolean;
  withNumber?: boolean;
  withTitle?: boolean;
  withSound?: boolean;
  withPulseEffect?: boolean;
  audioSrc?: string;
}

export interface ChatResponder {
  name?: string;
  withName?: boolean;
  avatar?: string;
}

export enum FeedbackType {
  ALWAYS = 'always',
  AGENT = 'agent',
  BOT = 'bot',
}

export interface Feedback {
  type: FeedbackType.ALWAYS | FeedbackType.AGENT | FeedbackType.BOT;
  form: FormProps;
}

export enum MessageStatus {
  PENDING = 'pending',
  SENT = 'sent',
  ERROR = 'error',
}

export enum MessageOwner {
  AGENT = 'AGENT',
  BOT = 'BOT',
  USER = 'USER',
}

export type ReopenMinimiziedChat = 'ALWAYS' | 'NEXT_TABS' | 'NEVER';

export enum ReopenMinimizedChatState {
  ALWAYS = 'ALWAYS',
  NEXT_TABS = 'NEXT_TABS',
  NEVER = 'NEVER',
}
export interface File {
  path: string;
  lastModified: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}
export interface AttachmentsConfig {
  allowedTypes: string[];
  attachmentsEnabled: boolean;
  attachmentsRichEnabled: boolean;
  maxFileSize: number;
  maxFiles: number;
}

export enum MimeTypes {
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  JPG = 'image/jpeg',
  PNG = 'image/png',
  DOC = 'application/msword',
  TXT = 'text/plain',
  CSV = 'text/csv',
  JSON = 'application/json',
}

export interface FileEventData {
  file_name: string;
  file_size: number;
  file_type: string;
}

export interface FilePreviewData extends FileEventData {
  utterance?: string;
}

interface RichContent {
  id: string;
  fields: { [key: string]: string };
}

export interface TextMessage {
  utterance?: string;
  semantics?: any;
  input_fields?: any;
  rich_content?: RichContent;
  isSensitive?: boolean;
}

export type Option = {
  label: string;
  value: string;
};
